module.exports = __webpack_public_path__ + "img/key.3658f57d.png";